import * as React from 'react';
import { Tooltip, UIHeading1, UIHeading2, UIText1 } from '@cian/ui-kit';

import { IconFunctionalHelpCircle16 } from '@cian/ui-kit-design-tokens/icons';

import * as styles from './styles.css';
import { ConditionalWrapper } from '@cian/conditional-component';
import { MarketTrendsTitleTooltip } from './MarketTrendsTitleTooltip';
import { INearbyHousesInfoState } from '../../types/redux/nearbyHousesInfo';

interface IMarketTrendsTitle {
  isDesktop: boolean;
  onTooltipOpen(): void;
  tooltipInfo: INearbyHousesInfoState;
}

export function MarketTrendsTitle({ isDesktop, onTooltipOpen, tooltipInfo }: IMarketTrendsTitle) {
  return (
    <div id="TrendsBlock" data-testid="marketTrendsTitleId" className={styles['container']}>
      <div className={styles['title']}>
        <ConditionalWrapper if={isDesktop} ThenComponent={UIHeading1} ElseComponent={UIHeading2}>
          Тренды на рынке недвижимости
        </ConditionalWrapper>
      </div>
      <div className={styles['tooltip-box']}>
        <Tooltip
          onOpen={onTooltipOpen}
          theme="white"
          placement="bottom-end"
          header="Какие дома мы считаем соседними"
          title={<MarketTrendsTitleTooltip tooltipInfo={tooltipInfo} />}
        >
          <UIText1>
            Делаем выводы на основе объектов в этом и соседних домах{' '}
            <div data-testid="marketTrendsOnTitleTooltipOpenId" className={styles['tooltip-icon']}>
              <IconFunctionalHelpCircle16 color="icon-secondary-default" />
            </div>
          </UIText1>
        </Tooltip>
      </div>
    </div>
  );
}
